import React, { Component } from 'react';
import { TextOnly } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * The about us section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class HowItWorksView extends Component {

	render () {
		const {
			content,
			heading,
		} = this.props.content.landingPage.howItWorks;

		return (
			<TextOnly
				{...{
					content,
					heading,
				}}
				className='HowItWorksView'
			/>
		);
	}

}

export default withLanguageContext(HowItWorksView);



// WEBPACK FOOTER //
// ./src/components/views/HowItWorksView/HowItWorksView.js